import axios from 'axios'
const instance = axios.create({
  timeout: 5000
})
const token = document.querySelector("meta[name='csrf-token']").getAttribute('content')
instance.defaults.headers.common['X-CSRF-TOKEN'] = token

export default {
  run(element){
    const dismissButton = element.querySelector("[data-step-close-target='dismiss']")
    if (dismissButton == null) {
      return
    }
    dismissButton.addEventListener('click', (e) => {
      e.preventDefault()
      element.querySelectorAll("[data-step-close-target='step']").forEach((target) => {
        target.classList.add('hidden')
      })
      dismissButton.classList.add('hidden')
      this.markDismissed(element)
    })
  },
  markDismissed(element) {
    const url = element.getAttribute("data-step-close-url-value")
    instance.patch(url, {})
  }
}